import React from 'react';
import
    {
        Chip,
        Box,
        Checkbox,
        Typography,

        Tooltip,
        IconButton,
    } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { makeStyles, styled } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
// import Helper from '../../../utility/helper';
import DataTicketSettingCard from './dataTicketSettingCard';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    headRowContent: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
        width: '100%',
        alignItems: 'center',
    },
    rowContent: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
        width: '100%',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow: 'none',
        borderRadius: 0,
        padding: theme.spacing(2, 1, 0, 1),
        backgroundColor: '#fff',
    },
}));

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
    // border: `1px solid ${theme.palette.divider}`,
    zIndex: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
    borderRadius: theme.spacing(1),
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon />}
        {...props}
    />
))(() => ({
    //backgroundColor: '#f5f5f5',
    //flexDirection: 'row-reverse',
    padding: theme.spacing(1),
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        margin: theme.spacing(0),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: theme.spacing(0, 2, 1, 2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const DataTicketSettingRow = (props) =>
{
    const classes = useStyles();
    const { item, index } = props;
    // console.log("item",item);
    return (
        <Accordion expanded={item.expanded}>
            <AccordionSummary
                expandIcon={
                    <Tooltip title="Info" aria-label="info">
                        <ExpandMoreIcon onClick={() => props.toggleChange(item, index)} sx={{ cursor: 'pointer' }} />
                    </Tooltip>
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Box className={classes.headRowContent}>
                    <Box sx={{
                        width: '10%',
                        flexBasis: '10%',
                        flexGrow: 1,
                    }}>
                        <Checkbox
                            inputProps={{
                                'aria-label': 'Outfit',
                            }}
                            checked={item.selected ? item.selected : false}
                            onChange={(event) => props.onCheckSelect(event, index)}
                            // color="secondary"
                            value={item.actualData.ticketMasterID}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '20%',
                            flexBasis: '20%',
                            flexGrow: 1,
                        }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Master request
                        </Typography>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {`Master Request ${index + 1}`}
                        </Typography>
                        {/* <Typography fontSize={11} sx={{
                            display: '-webkit-box',
                            boxOrient: 'vertical',
                            lineClamp: 2,
                            wordBreak: 'break-all',
                            overflow: 'hidden',
                            pr: 1
                        }}>
                            <a
                                href={`mailto:${item.email}`}>
                                {' '}
                                {item.email}{' '}
                            </a>
                        </Typography> */}
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '20%',
                            flexBasis: '20%',
                            flexGrow: 1,
                        }}>
                        {/* <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Date
                        </Typography>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            <span>{Helper.FormatDate(item.actualData.date)}</span>
                        </Typography> */}
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '15%',
                            flexBasis: '15%',
                            flexGrow: 1,
                        }}>
                        {item.roleName ?
                            <>
                                <Typography
                                    variant="h4"
                                    // flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Role
                                </Typography>
                                <Typography
                                    variant="h4"
                                    // flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{item.roleName}</span>
                                </Typography>
                            </>
                            : null}
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'left',
                            alignItems: 'center',
                            width: '25%',
                            flexBasis: '25%',
                            flexGrow: 1,
                            flexWrap: 'wrap',
                        }}>
                        {
                            item.userTags ?
                                item.userTags.split(', ').map((chipItem) =>
                                {
                                    return (
                                        <Chip
                                            key={chipItem}
                                            label={chipItem}
                                            sx={{ mr: '4px', mb: '2px' }}
                                        />
                                    );
                                })
                                : null
                        }
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            justifyContent: 'end',
                            alignItems: 'center',
                            width: '10%',
                            flexBasis: '10%',
                            flexGrow: 1,
                        }}>
                        <Tooltip title="Edit" aria-label="edit">
                            <IconButton
                                color="primary"
                                onClick={() => props.editRow(item)}
                            >
                                <EditOutlinedIcon
                                    fontSize="small"
                                    color={'primary'}
                                />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <DataTicketSettingCard
                    classes={classes}
                    item={item}
                    index={index}
                    {...props}
                />
            </AccordionDetails>
        </Accordion>
        // <ListItem className={classes.listItemContent}>
        //     <DataOutfitCard
        //         classes={classes}
        //         item={item}
        //         index={index}
        //         {...props}
        //     />
        // </ListItem>
    );
};

export default DataTicketSettingRow;
